import React, {createContext, useContext, useMemo} from 'react';

import {ProgressData} from 'llm/chat-library/progress/ProgressTypes';

interface DataCaptureProgressContextValue {
  progressData: ProgressData | null;
}

const DataCaptureProgressContext = createContext<DataCaptureProgressContextValue>({
  progressData: null,
});

export interface DataCaptureProgressProviderProps {
  progressData: ProgressData | null;
  children: React.ReactNode;
}

export function DataCaptureProgressProvider({
  progressData,
  children,
}: DataCaptureProgressProviderProps): JSX.Element {
  const value = useMemo(() => ({progressData}), [progressData]);
  return <DataCaptureProgressContext.Provider value={value}>{children}</DataCaptureProgressContext.Provider>;
}

export function useDataCaptureProgressData(): ProgressData | null {
  const context = useContext(DataCaptureProgressContext);
  return context.progressData;
}
